

















































































































































import { CompanyServiceEnum } from "@/lib/enum/company-service.enum";
import { requiredRule } from "@/lib/rules/requiredRule";
import { ICompany } from "@/models/company.entity";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { PartnerModule } from "@/store/modules/partner";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CompanySelection from "../contact/CompanySelection.vue";
import { CurrencyEnum } from "@/lib/enum/currency.enum";
import { getAutocompleteFilter } from "@/lib/utility/filter";
import { ITowingDetails, TowingDetails } from "@/models/towing.entity";
import GeoFinderField from "@/components/utility/GeoFinderField.vue";
import { IReport } from "@/models/report.entity";
@Component({
  components: { CompanySelection, GeoFinderField },
  filters: {}
})
export default class TowingForm extends Vue {
  ResourceEnum = ResourceEnum;
  CompanyServiceEnum = CompanyServiceEnum;
  CurrencyEnum = CurrencyEnum;
  getAutocompleteFilter = getAutocompleteFilter;

  company: ICompany | null = null;

  @Prop({ default: true })
  showCompany!: boolean;

  @Prop({ default: new TowingDetails() })
  value!: ITowingDetails;

  @Prop()
  report?: IReport;

  @Prop()
  destination?: ICompany;

  get required() {
    return [requiredRule()];
  }

  get partner() {
    return PartnerModule.partner;
  }

  @Watch("company")
  onCompanyChange() {
    this.$log.debug(this.company);

    if (this.company) {
      this.value.companyId = this.company.id;
    }
  }

  toTowingCompany() {
    if (!this.company) {
      return;
    }

    this.value.deliveryLocation = this.company.addresses[0];
    this.value.deliveryLocation.line2 = this.company.companyName;
  }

  toWorkshopCompany() {
    if (!this.destination) {
      return;
    }

    this.value.deliveryLocation = this.destination.addresses[0];
    this.value.deliveryLocation.line2 = this.destination.companyName;
  }
}
